import { compact } from 'lodash';
import { Children } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const UserMenuGroupItem = _ref => {
  let {
    title,
    children
  } = _ref;

  const renderChildItem = child => /*#__PURE__*/_jsx("li", {
    className: "nav-item",
    children: child
  });

  return /*#__PURE__*/_jsxs("ul", {
    className: "nav nav-stacked nav-dropdown nav-detailed user-menu-group__item",
    children: [/*#__PURE__*/_jsx("li", {
      className: "label label--small nav__label",
      children: title
    }), Children.map(compact(children), renderChildItem)]
  }, title);
};

export default UserMenuGroupItem;